import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '931401796468747';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    // Guard against double init (e.g. React Strict Mode double-mount)
    if (window.fbq && (window.fbq as any).loaded) {
      try {
        window.fbq('track', 'PageView');
      } catch (_) {
        /* noop */
      }
      return;
    }
    // Set up the fbq queue stub manually (replicates Meta's base code,
    // but without the fragile getElementsByTagName('script')[0] insertion).
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments as any) : n.queue.push(arguments);
    };
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    window.fbq = n;
    if (!window._fbq) window._fbq = n;
    // Inject the script safely into <head>
    const target = document.head || document.body;
    if (target) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      target.appendChild(script);
    }
    try {
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
    } catch (_) {
      /* noop */
    }
  }, []);
  return <noscript data-id="element-204">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-205" />
    </noscript>;
}